import React from "react";
import { Box, Stack, Typography, IconButton, Button, Divider } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Icon } from "@iconify/react";
import { RHFTextField } from "@app/components";
import { Strings } from "@app/constants";

const ExtraInformationFields = ({ label }: { label: string }) => {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "extraInfo",
  });

  return (
    <Box sx={{
        mt:2
    }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Poppins",
            fontSize: 16,
            color: "#222",
          }}
        >
          {label}
        </Typography>

        <Button
          variant="outlined"
          onClick={() => append({ heading: "", description: "" })}
          startIcon={<Icon icon="mdi:plus" />}
          sx={{
            color:"#505050"
          }}
        >
          {Strings.button.addMore}
        </Button>
      </Stack>
      <Divider sx={{ my: 1.5 }} />

      <Stack spacing={3}>
        {fields.map((field, index) => (
          <Box
            key={field.id}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 2,
              position: "relative",
              bgcolor: "#fff",
            }}
          >
            <Stack spacing={2}>
              <Stack direction="row" spacing={1} alignItems="center">
                <RHFTextField
                  name={`extraInfo.${index}.heading`}
                  placeholder={`Heading ${index + 1}`}
                  label={`Heading ${index + 1}`}
                  fullWidth
                />

                <IconButton
                  onClick={() => remove(index)}
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    height: 40,
                    width: 40,
                  }}
                >
                  <Icon icon="mdi:minus" />
                </IconButton>
              </Stack>

              <RHFTextField
                name={`extraInfo.${index}.description`}
                placeholder="Description"
                label="Description"
                multiline
                minRows={3}
                fullWidth
              />
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ExtraInformationFields;
